<template>
  <el-dialog :visible.sync="dialogVisible" custom-class="custom-dialog" class="count-result" :close-on-click-modal="false" append-to-body width="500px">
    <div slot="title" class="title">
      <div class="title-name">请确认报告数据</div>
      <div class="side-title"></div>
      <div class="dialog-close-btn" @click="dialogVisible = false">X</div>
    </div>
    <div>
      <el-tag v-if="yearReport && yearReport.offer金额">有offer客户</el-tag>
      <el-tag v-if="yearReport && !yearReport.offer金额" type="danger">无offer客户</el-tag>
      <el-switch
        @change="getShowFields"
        v-model="ifOffer"
        active-text="有offer模板"
        inactive-text="无offer模板">
      </el-switch>
    </div>
    <div class="count-result-box">
      <div>
        <span>3个展示的项目:</span>
        <!-- <el-input v-model="yearReport[field]" class="mb10" size="mini" placeholder="请输入内容"></el-input> -->
        <el-input v-for="(item,index) in showProjects" :key="`${index}`" v-model="showProjects[index]" class="mb10" size="mini" placeholder="请输入内容"></el-input>
      </div>
      <div v-for="field in showFields" :key="field">
        <span>{{ field }}:</span>
        <el-input v-model="yearReport[field]" class="mb10" size="mini" placeholder="请输入内容"></el-input>
      </div>
    </div>
    <div class="count-result-footer">
      <el-button class="mr10" style="flex: none" size="mini" type="primary" @click="regetReport">重新生成报告</el-button>
      <el-button class="mr10" style="flex: none" size="mini" type="primary" @click="confirm">确认生成报告</el-button>
    </div>
  </el-dialog>
</template>
<script>
export default {
  data() {
    return {
      dialogVisible: false,
      ifOffer:false,
      fields: [
        '合作开始时间',
        '展示公司名称',
        '合作天数',
        '职位数',
        '电话',
        '推荐',
        '面试',
        '高质量职位',
        '独家保密',
        '高职级岗位',
        '合作时间',
        '开放职位数',
        '推荐转换为面试率',
        '推荐转换为面试率平均',
        '第一批人选推荐时间',
        '第一批人选推荐时间平均',
        '安排面试平均时间',
        '安排面试平均时间平均',
      ],
      successfulFields: [
        '最顺利的项目',
        '最成功的项目',
        '最艰难的项目',
        '终面',
        'offer',
        '到岗',
        '合作最快',
        '合作最快天数',
        // '合作offer业绩',
        '回款天数',
        '平均回款天数',
        'offer金额',
        '回款比例',
        'offer金额排名',
        '回款金额排名',
        '推荐offer转化率',
        '推荐offer转化率平均',
        '终面offer转化率',
        '终面offer转化率平均',
        '发offer平均时间',
        '发offer平均时间平均',
        '安排终面平均时间',
        '安排终面平均时间平均',
      ],
      failedFields: [
        '最遗憾的项目',
      ],
      showFields: [],
      yearReport: {},
      projectCount: 0,
      showProjects: ['','',''],
    }
  },
  methods: {
    open(yearReport) {
      if(!yearReport) return this.$message.error('报告错误')
      this.yearReport = window._.cloneDeep(yearReport)
      if(this.yearReport.reportType==='无'){
        this.ifOffer=false
      }else if(this.yearReport.reportType==='有'){
        this.ifOffer=true
      }else{
        this.ifOffer = !!this.yearReport.offer金额
      }
      this.getShowFields(this.yearReport)
      if(this.yearReport.项目名称){
        this.showProjects = this.yearReport.项目名称
      } else {
        this.getCompanyProjects()
      }
      this.dialogVisible = true
    },
    getShowFields(report){
      const fields = []
      if(this.ifOffer) fields.push(...this.successfulFields)
      else fields.push(...this.failedFields)
      fields.push(...this.fields)
      this.showFields = fields
    },
    async getCompanyProjects(){
      const res = await app.service('misc').getClientYearProjects({ company: this.yearReport.公司, timeRange: this.yearReport.timeRange })
      if(res.status==='success'){
        const projects = res.data
        let num = 3
        if(projects.length < 3) num = projects.length
        const arr = []
        for(let i = 0;i<num;i+=1){
          arr.push(projects[i].项目名称)
        }
        this.showProjects = arr
        this.projectCount = projects.length
      } else this.$message.error(res.msg)
    },
    async modifyClientYearReport(){
      if(!this.ifOffer){
        this.yearReport.reportType = '无'
      }
      if(this.ifOffer){
        this.yearReport.reportType = '有'
      }
      const res = await app.service('misc').modifyClientYearReport(this.yearReport)
      if(res.status==='success'){
        return res.data
      } else this.$message.error(res.msg)
    },
    async regetReport(){
      if(this.regeting) return this.$message.error('获取中，请稍候')
      this.regeting = true
      const res = await app.service('misc').getClientYearReport(this.yearReport)
      if(res.status==='success'){
        const report = res.data
        this.open(report)
      } else this.$message.error(res.msg)
      this.regeting = false
    },
    async confirm(){
      if(this.loading) return this.$message.error('生成报告中，请稍候')
      this.loading = true
      try {
        this.yearReport.项目名称 = this.showProjects
        const report = await this.modifyClientYearReport(this.yearReport)
        app.root.$refs.GetClientYearReportDialog.open(report)
        this.dialogVisible = false
      } catch (e) {
        console.log(e.message);
      }
      this.loading = false
    },
  },
}
</script>
<style>
.custom-dialog .el-dialog__body {
  padding-top: 0px;
}
.count-result-footer .el-button--primary  {
  background-color: #4394b9;
  border-color: #4394b9;
}
</style>
<style scoped src="../../company/statistics/css/commonCompany.css"></style>
<style scoped>
pre {
  white-space: pre-wrap;
  word-wrap: break-word;
  line-height:1.5;
  margin: 0;
  padding:15px
}
.title-btn {
  margin-left: 30px;
  color: #cbcbcb;
  font-size: 14px;
  cursor: pointer;
}
.count-result-box{
  padding: 0 30px;
  max-height: 600px;
  overflow: auto;
}
.count-result-footer{
  display: flex;
  justify-content: center;
}
</style>
